import { customerApi } from "./customer";
import { leaveApi } from "./leave";
import { taskApi } from "./task";
import { deskApi } from "./desk";
import { centralTaskApi } from "./central-task";
import { productApi } from "./products";
import { commonApi } from "./common";
import { clientApi } from "./client-onboarding";

export const api = {
  customer: customerApi,
  task: taskApi,
  leave: leaveApi,
  desk: deskApi,
  centralTask: centralTaskApi,
  product: productApi,
  common: commonApi,
  client: clientApi,
};
